/* eslint-disable */


/**
 * Create styles for `<AdminPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<AdminPage />` styles
 */
const adminPageStyles = ({ theme }) => ({
  root: {
    ...theme.mixins.gutters(),
    marginTop: theme.spacing(1) * 2,
    paddingBottom: theme.spacing(1) * 2,
    paddingTop: theme.spacing(1) * 2,
  },
});

export default adminPageStyles;
